import { forwardRef, memo } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { useAssetModalPanelContext } from '~/providers/AssetModalPanelContextProvider';
import { useMobileAssetModalContext } from '~/providers/MobileAssetModalContextProvider';

export type MobileAssetModalPanelHeaderProps = {
  title: string;
};

export const MobileAssetModalPanelHeader = memo(
  forwardRef<HTMLDivElement, MobileAssetModalPanelHeaderProps>(({ title }, forwardedRef) => {
    const { navigationHeight } = useMobileAssetModalContext();
    const { hidePanel } = useAssetModalPanelContext();

    return (
      <header
        className="sticky top-10 z-1 flex shrink-0 items-center justify-between gap-2 ads:border-default border-gray-5 border-y ads:bg-base bg-gray-1 px-6 py-4"
        style={{ top: navigationHeight }}
        ref={forwardedRef}
      >
        <h2 className="font-bold ads:text-metadata text-14 text-gray-10 uppercase tracking-wide">{title}</h2>
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          icon={XIcon}
          label="Close panel"
          onClick={hidePanel}
          size="medium"
        />
      </header>
    );
  }),
);

MobileAssetModalPanelHeader.displayName = 'MobileAssetModalPanelHeader';
